<template>
    <CModal
        :title="titleComponent"
        :show="showComponent"
        :color="colorComponent"
        :size="sizeComponent"
    >
        <CForm
            ref="formAddEmailToBlacklist"
            @submit="formSubmit($event, 'addEmailToBlacklist')"
        >
            <CInput
                :isValid="
                    checkIfFormValid({
                        formName: 'addEmailToBlacklist',
                        fieldName: 'email',
                    })
                "
                :value.sync="$v.forms.addEmailToBlacklist.email.$model"
                :label="$t('email')"
                :disables="true"
            />
            <!-- <CTextarea
                :isValid="
                    checkIfFormValid({
                        formName: 'addEmailToBlacklist',
                        fieldName: 'reason',
                    })
                "
                :value.sync="$v.forms.addEmailToBlacklist.reason.$model"
                :label="$t('reason')"
                :disables="true"
            /> -->

            <CSelect
                :isValid="
                    checkIfFormValid({
                        formName: 'addEmailToBlacklist',
                        fieldName: 'reason',
                    })
                "
                :value.sync="$v.forms.addEmailToBlacklist.reason.$model"
                :label="$t('reason')"
                :disables="true"
                :placeholder="'Select type'"
                :options="[
                    { label: 'Low', value: 'Low' },
                    { label: 'Error', value: 'Error' },
                    { label: 'Manual Lock', value: 'Manual Lock' },
                    { label: 'Competitor', value: 'Competitor' },
                    { label: 'Customer', value: 'Customer' },
                    { label: 'Complaint', value: 'Complaint' },
                ]"
            />

            <ButtonLoading
                type="submit"
                :block="true"
                color="primary"
                :loading="forms.addEmailToBlacklist._loading"
            >
                <span>{{ $t("Save") }}</span>
            </ButtonLoading>
        </CForm>
        <template #footer>
            <CButton color="secondary" @click="closeModal()">
                {{ $t("Cancel") }}
            </CButton>
            <ButtonLoading
                color="success"
                @click="executeSubmitForm"
                :loading="forms.addEmailToBlacklist._loading"
            >
                {{ $t("Save") }}
            </ButtonLoading>
        </template>
    </CModal>
</template>

<script>
import formMixin from "~/mixins/form";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import ButtonLoading from "~/components/ButtonLoading.vue";
export default {
    name: "AddEmailToBlacklistModal",
    mixins: [formMixin, validationMixin],
    components: {
        ButtonLoading,
    },
    props: {
        title: String,
        show: Boolean,
        color: String,
        size: String,
    },

    data() {
        return {
            titleComponent: null,
            showComponent: false,
            colorComponent: "primary",
            sizeComponent: "lg",

            forms: {
                addEmailToBlacklist: {
                    email: null,
                    reason: null,
                    _loading: false,
                },
            },
        };
    },

    validations: {
        forms: {
            addEmailToBlacklist: {
                email: {
                    required,
                },
                reason: {
                    required
                },
            },
        },
    },

    watch: {
        title() {
            this.titleComponent = this.title;
        },
        show() {
            this.showComponent = this.show;
            if (!this.show) {
                this.resetForm("addEmailToBlacklist");
                this.$v.$reset();
            }
        },
        color() {
            this.colorComponent = this.color;
        },
        size() {
            this.sizeComponent = this.size;
        },

        showComponent() {
            this.$emit("update:show", this.showComponent);
        },
    },

    methods: {
        closeModal() {
            this.showComponent = false;
        },

        async formSubmit(e, formName) {
            e.preventDefault();
            let response = await this.sendForm({
                formName,
                url: "/headers.api/emails/blacklist",
            });
            this.showComponent = false;

            this.$emit("submit", response);
        },

        executeSubmitForm() {
            this.$refs.formAddEmailToBlacklist.requestSubmit();
        },
    },

    mounted() {
        this.titleComponent = this.title;
        this.showComponent = this.show;
        this.colorComponent = this.color;
        this.sizeComponent = this.size;
    },
};
</script>

<style>
</style>